import {
  baseUrl,
} from './consts.js'

import {
  errCode
} from './consts.js'

import {
  isString,
  isBlob
} from './typeUtils.js'

import {
  getStorage,
  setStorage,
  setSessionStorage,
  getSessionStorage
} from './storageUtils.js'

import {
  showErrorMsg,
  startLoading,
  closeLoading
} from './uiUtils.js'

import axios from 'axios'

const service = axios.create({
  baseURL: baseUrl
})

const handleErrByCode = (error) => {
  if (!error.response) {
    showErrorMsg('网络错误，请确认服务端能否正常访问')
  } else if (error.response.status === errCode
    .Unauthorized) {
    showErrorMsg('认证错误')
  } else if (error.response.status === errCode
    .INVALID_REQUEST) {
    showErrorMsg('请检查输入的参数')
  } else if (error.response.status === errCode
    .Forbidden) {
    showErrorMsg('权限不足，拒绝访问')
  } else if (error.response.status === errCode
    .NOT_FOUND) {
    showErrorMsg('资源未找到')
  } else if (error.response.status === errCode
    .Not_Acceptable) {
    showErrorMsg('请求格式错误')
  } else if (error.response.status === errCode
    .Gone) {
    showErrorMsg('资源已删除')
  } else if (error.response.status === errCode
    .INTERNAL_SERVER_ERROR) {
    console.log(error.response.data)
    showErrorMsg('内部错误')
  } else if (error.response.status === errCode
    .HTTP_507_INSUFFICIENT_STORAGE) {
    showErrorMsg('数据查询异常')
  } else if (error.response.status === errCode
    .CUSTOM_ERROR) {
    if (isBlob(error.response.data)) {
      var reader = new FileReader();
      reader.onload = function(event) {
        showErrorMsg(JSON.parse(reader.result).err_msg); //请求blob失败后，解析成json
      };
      reader.readAsText(error.response.data);
    } else {
      showErrorMsg(error.response.data.err_msg ? error.response.data.err_msg : error.response.data)
    }
  } else {
    if (isBlob(error.response.data)) {
      var reader = new FileReader();
      reader.onload = function(event) {
        showErrorMsg(JSON.parse(reader.result).err_msg); //请求blob失败后，解析成json
      };
      reader.readAsText(error.response.data);
    } else {
      showErrorMsg(error.response.data.err_msg ? error.response.data.err_msg : error.response.data)
    }
  }
}

service.interceptors.request.use(config => {
  return config
}, err => {
  Message.error({
    message: '请求出错！'
  })
  return Promise.resolve(err)
})


service.interceptors.response.use(response => {
  return response.data
}, error => {
  return Promise.reject(error)
})

const request = (params) => {
  let sessionStorageKey = params.sessionStorageKey
  if (sessionStorageKey) {
    let res = getSessionStorage(sessionStorageKey)
    if (res) {
      return res
    }
  }

  let noLoading = params.noLoading
  let noError = params.noError
  let noToken = params.noToken

  if (!noLoading) {
    startLoading()
  }

  let headers = {}

  if (!noToken) {
    let token = params.token
    if (!token) {
      token = getStorage('token')
    }

    headers = {
      Authorization: 'Bearer ' + token
    }
  }

  let data = params.data
  let requestParams = params.params

  if (params.method == 'GET' && params.data) {
    requestParams = params.data
  }

  if (params.contentType) {
    headers = Object.assign(headers, {
      'Content-Type': params.contentType
    })
    if (params.contentType.endsWith('form-data') && Object
      .prototype.toString.call(params.data) !==
      '[object FormData]') {
      // formdata需要把json转换下
      data = new FormData()
      Object.keys(params.data).forEach(key => {
        data.append(key, params.data[key])
      })
    }
  }

  let requestConfig = {
    method: params.method,
    url: params.url,
    data: data,
    params: requestParams
  }

  if (params.responseType) {
    requestConfig.responseType = params.responseType
  }
  service(Object.assign(requestConfig, {
      headers: headers
    }))
    .then((result) => {
      if (params.responseType) {
        try {
          params.success && params.success(result)
        } catch (err) {
          console.log(err)
          showErrorMsg('发生错误')
        }
      } else {
        if (result.status == 'success') {
          if (sessionStorageKey) {
            setSessionStorage(sessionStorageKey, result.data)
          }
          try {
            params.success && params.success(result.data)
          } catch (err) {
            console.log(err)
            showErrorMsg('发生错误')
          }
        } else {
          if (params.fail) {
            params.fail(result.err_msg)
          } else if (!noError) {
            showErrorMsg(result.err_msg)
          }
        }
      }
      if (!noLoading) {
        closeLoading()
      }
    })
    .catch((err) => {
      console.log(err)
      if (params.fail) {
        params.fail(err)
      } else {
        handleErrByCode(err)
      }
      if (!noLoading) {
        closeLoading()
      }
    })
    .finally(() => {
      if (params.complete) {
        params.complete()
      }
    })
}

export {
  request
}



// WEBPACK FOOTER //
// ./src/utils/request.js